<script setup>
import {defineProps, ref} from 'vue';
import {
  OnboardingMenuList,
  OnboardingMenuConst,
} from '../constants/OnboardingMenu';
import OnboardingDetails from '../components/onboarding/OnboardingDetails.vue';
import OnboardingAssignies from '../components/onboarding/OnboardingAssignies.vue';
import OnboardingQualification from '../components/onboarding/OnboardingQualification.vue';
import UserRoles from '../constants/UserRoles';
import {computed} from 'vue';

const props = defineProps({
  id: {
    type: Number,
    default() {
      return null;
    },
  },
  ownerId: {
    type: Number,
    default() {
      return null;
    },
  },
});

const isEmployee = computed(() => {
  return [UserRoles.ESS.id].includes(window.appGlobal.user.roleId);
});

const isSupervisor = computed(() => {
  return [UserRoles.SUPERVISOR.id].includes(window.appGlobal.user.roleId);
});

const isOwner = computed(() => {
  return window.appGlobal.user.id == props.ownerId;
});

const tabMenus = ref(OnboardingMenuList);
const activeTabId = ref(OnboardingMenuConst.DETAIL);

if (isSupervisor.value) {
  tabMenus.value = [OnboardingMenuList[1]];
  activeTabId.value = OnboardingMenuConst.ASSIGNIES;
}

if (isEmployee.value) {
  tabMenus.value = [OnboardingMenuList[0], OnboardingMenuList[2]];
}

if (isOwner.value) {
  tabMenus.value = [OnboardingMenuList[0], OnboardingMenuList[1]];
}

const setActiveTab = tabId => {
  activeTabId.value = tabId;
};
</script>
<template>
  <div class="orangehrm-background-container">
    <div class="orangehrm-card-container">
      <nav
        id="navigation"
        role="navigation"
        aria-label="Topbar Menu"
        class="oxd-topbar-body-nav"
      >
        <ul>
          <template v-for="(tab, index) in tabMenus" :key="index">
            <li
              class="oxd-topbar-body-nav-tab"
              :class="{'--visited': activeTabId === tab.id}"
              @click="setActiveTab(tab.id)"
            >
              <span class="oxd-topbar-body-nav-tab-item">{{ tab.label }}</span>
            </li>
          </template>
        </ul>
      </nav>
      <br />
      <oxd-divider />
      <!-- DETAIL -->
      <OnboardingDetails
        v-if="activeTabId == OnboardingMenuConst.DETAIL && !isSupervisor"
        :id="props.id"
      />
      <!-- END: DETAIL -->
      <!-- ASSIGNIES -->
      <OnboardingAssignies
        v-if="activeTabId == OnboardingMenuConst.ASSIGNIES && !isEmployee"
        :id="props.id"
      />
      <!-- END: ASSIGNIES -->
      <!-- QUALIFICATION -->
      <OnboardingQualification
        v-if="
          activeTabId == OnboardingMenuConst.QUALIFICATION &&
            !(isSupervisor || isOwner)
        "
        :id="props.id"
      />
      <!-- END: QUALIFICATIONS -->
    </div>
  </div>
</template>
<style scoped>
@media (min-width: 800px) {
  .oxd-topbar-body-nav-tab {
    position: relative;
  }
}
.oxd-topbar-body-nav ul:first-child {
  list-style: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  padding: 0;
  margin: 0;
}
.oxd-topbar-body-nav-tab {
  height: 35px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  padding: 0 12px;
  margin-right: 15px;
  text-decoration: none;
  border-radius: 0.85rem;
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 600;
}
</style>
